module.exports = __webpack_public_path__ + "img/unsplash.11f26e88.jpg";